import React from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import customerView from "./components/CustomerView";
import userView from "./components/UserView";

import "./adminStyles.scss";
import sftpUserView from "./components/sftp/sftpUserView";

const AdminLayout = (props) => {
  const { match } = props;

  return (
    <Switch>
      <Route exact path={match.path} component={userView} />
      <Route exact path={`${match.path}/user`} component={userView} />
      <Route path={`${match.path}/user/:userId`} component={userView} />
      <Route exact path={`${match.path}/customer`} component={customerView} />
      <Route
        path={`${match.path}/customer/:customerId`}
        component={customerView}
      />
      <Route path={`${match.path}/sftp/user/:userId`} component={sftpUserView} />
      <Route exact path={`${match.path}/sftp/user`} component={sftpUserView} />
    </Switch>
  );
};

AdminLayout.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(AdminLayout);
